import { cn } from "@/core/helpers/misc/GeneralUtils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("shadcn-skeleton bg-accent animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
